module.exports = __webpack_public_path__ + "img/no-1.bc139a7c.svg";